@if (labelMode() === 'fixed' && label()) {
  <label
    for="select-input"
    class="block mb-2 text-sm font-medium text-gray-700"
    [class.opacity-60]="isDisabled()"
    [class.cursor-not-allowed]="isDisabled()">
    {{ label() }}
    @if (hasRequiredRule()) {
      <span class="ml-0.5 text-red-500">*</span>
    }
  </label>
}

<p-select
  id="select-input"
  class="w-full"
  [options]="availableOptions()"
  [ngModel]="selected()"
  [optionLabel]="OPTION_LABEL"
  [optionValue]="OPTION_VALUE"
  [optionDisabled]="OPTION_DISABLED"
  [optionGroupLabel]="optionGroupLabel()"
  [optionGroupChildren]="optionGroupChildren()"
  [group]="group()"
  [placeholder]="placeholder()"
  [variant]="variant()"
  [checkmark]="checkmark()"
  [showClear]="showClear()"
  [disabled]="isDisabled()"
  [editable]="editable()"
  [filter]="filterEnabled()"
  [filterBy]="FILTER_BY"
  [filterPlaceholder]="filterPlaceholder()"
  [filterMatchMode]="filterMatchMode()"
  [autofocusFilter]="false"
  [focusOnHover]="focusOnHover()"
  [selectOnFocus]="selectOnFocus()"
  [autoOptionFocus]="autoOptionFocus()"
  [virtualScroll]="virtualScroll()"
  [virtualScrollItemSize]="VIRTUAL_SCROLL_ITEM_SIZE"
  [lazy]="lazy()"
  [loading]="isLoading()"
  [class.select-invalid]="isInvalid()"
  [class.ng-dirty]="ngControl?.control?.dirty"
  [class.p-float-label]="useFloatLabel()"
  [class.p-iftalabel]="useIftaLabel()"
  (onChange)="handleChange($event)"
  (onFilter)="handleFilter($event)"
  (onShow)="handleShow()"
  (onHide)="handleHide()"
  (onFocus)="handleFocus($event)"
  (onBlur)="handleBlur($event)"
  (onClear)="handleClear()"
  (onLazyLoad)="handleLazyLoad($event)"
  appendTo="body">

  @if (optionTemplate(); as tmpl) {
    <ng-template pTemplate="option" let-option let-index="index">
      <ng-container
        [ngTemplateOutlet]="tmpl"
        [ngTemplateOutletContext]="{ $implicit: option, index: index }"
      ></ng-container>
    </ng-template>
  }

  @if (selectedOptionTemplate(); as tmpl) {
    <ng-template pTemplate="selectedOption" let-option>
      <ng-container
        [ngTemplateOutlet]="tmpl"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>
    </ng-template>
  }

  @if (groupTemplate(); as tmpl) {
    <ng-template pTemplate="group" let-group>
      <ng-container
        [ngTemplateOutlet]="tmpl"
        [ngTemplateOutletContext]="{ $implicit: group }"
      ></ng-container>
    </ng-template>
  }

  @if (headerTemplate(); as tmpl) {
    <ng-template pTemplate="header">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }

  @if (footerTemplate(); as tmpl) {
    <ng-template pTemplate="footer">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }

  @if (emptyTemplate(); as tmpl) {
    <ng-template pTemplate="empty">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }

  @if (loaderTemplate(); as tmpl) {
    <ng-template pTemplate="loader">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }

  @if (filterTemplate(); as tmpl) {
    <ng-template pTemplate="filter" let-options="options">
      <ng-container
        [ngTemplateOutlet]="tmpl"
        [ngTemplateOutletContext]="{ options: options }"
      ></ng-container>
    </ng-template>
  }

  @if (clearIconTemplate(); as tmpl) {
    <ng-template pTemplate="clearicon">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }

  @if (dropdownIconTemplate(); as tmpl) {
    <ng-template pTemplate="dropdownicon">
      <ng-container [ngTemplateOutlet]="tmpl"></ng-container>
    </ng-template>
  }
</p-select>

@if ((useFloatLabel() || useIftaLabel()) && label()) {
  <label for="select-input">
    {{ label() }}
    @if (hasRequiredRule()) {
      <span class="ml-0.5 text-red-500">*</span>
    }
  </label>
}

@if (showErrorMessage() && isInvalid() && errorMessage()) {
  <small class="select-input__error block mt-1 text-xs text-red-500">
    {{ errorMessage() }}
  </small>
}
